import {createContext} from 'react';

const AnalysisClientStateIdContext = createContext<string>('DEFAULT_ANALYSIS_CLIENT_STATE_ID');

export default AnalysisClientStateIdContext;
